import * as type from '../actions/types';

const initialState = {
  completedRegsteps: false,
  registration: [],
  loading: false,
  error: "",
}

export default function registerOtp(state = initialState, action) {
  switch (action.type) {
    case type.POST_REGISTER_OTP_REQUESTED:
      return {
        ...state,
        loading: true,
        error: "", // Clear any previous errors when starting a new OTP verification
      }
    case type.POST_REGISTER_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        registration: action.registerPersonal,
        completedRegsteps: true
      }
    case type.POST_REGISTER_OTP_FAILED:
      return {
        ...state,
        completedRegsteps: 0,
        loading: false,
        error: action.error,
      }
    case type.CLEAR_REGISTER_OTP_ERROR:
      return {
        ...state,
        error: "",
      }
    default:
      return state
  }
}